<a href="#main-content" class="skip-link">Skip to main content</a>
<main id="main-content" tabindex="-1">
    <router-outlet />
</main>
